type Props = {}

const VehicleSupportBanner = () => {
  return (
    <>
      {/* Desktop View */}
      <div
        className={`
          relative hidden h-[172px] w-full overflow-hidden px-6

          lg:px-8

          md:block
        `}
        style={{
          backgroundImage: 'url("/img/BannerBg.jpeg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="relative z-10 flex h-full items-center justify-between">
          <div className="flex-1 text-white">
            <h2 className="mb-1 text-2xl font-bold">¿Tienes dudas sobre</h2>
            <h2 className="mb-2 text-2xl font-bold">este vehículo?</h2>
            <p className="text-base font-medium opacity-90">
              Estamos aquí para ayudarte.
            </p>
          </div>
          <div className="flex flex-1 items-center gap-4">
            <img
              src="/img/Banner/phone_responsive.png"
              alt="Call"
              className="h-24 w-24"
            />
            <div className="text-white">
              <div className="text-3xl font-bold">931 318 618</div>
              <div className="text-base font-medium opacity-90">
                Lunes a viernes:
                <br /> 10:00 a 14:00 | 15:00 a 19:00 <br /> Sábados: 10:00 a
                14:00
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div
        className={`
          relative h-[213px] w-full px-4

          md:hidden
        `}
      >
        {/* Background image */}
        <img
          src="/img/bg_banner_mobile.png"
          alt="divider"
          className="h-full w-full rounded-md object-cover"
        />

        <div
          className={`
            absolute inset-0 z-10 flex flex-col items-center justify-center p-4
            text-white
          `}
        >
          <div className="mb-4 p-4 text-center">
            <h2 className="text-2xl font-bold">
              ¿Tienes dudas sobre este vehículo? Estamos aquí para ayudarte.
            </h2>
          </div>

          <div className="mb-4 flex items-center justify-center gap-4">
            <img
              src="/img/Banner/phone_responsive.png"
              alt="Call"
              className="h-16 w-16"
            />
            <div className="text-left">
              <div className="text-2xl font-bold">931 318 618</div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default function ImageDivider({}: Props) {
  return (
    <>
      <VehicleSupportBanner />
    </>
  )
}
